import { applicationTypes } from 'constants/scripts';

import {
  getApplicationsByType,
  getApplicationsForZoneByType,
  getApplicationsWithNumericalRate
} from 'scripts/zones/selectors';
import { filter, forEach, get, inRange, isEqual, some, uniqBy } from 'lodash';

export const getSeedApplicationsForZones = (zones) => {
  return getApplicationsByType({ zones, applicationType: applicationTypes.SEED });
};

export const getSeedApplicationsForZone = (zone) => {
  return getApplicationsForZoneByType({ zone, applicationType: applicationTypes.SEED });
};

export const getZonesWithSeedRateInRange = ({ zones, range }) => {
  const [lowerBound, upperBound] = range;
  return filter(zones, (zone) => {
    const { rate } = getSeedApplicationsForZone(zone)[0];
    return inRange(rate.q, lowerBound, upperBound);
  });
};

export const getNumZonesWithSeedApplications = (zones) => {
  const seedApplications = getSeedApplicationsForZones(zones);
  const seedApplicationsWithNumericalValue = getApplicationsWithNumericalRate(seedApplications);
  return seedApplicationsWithNumericalValue.length;
};

export const zoneHasSeedApplicationOfProductId = (zone, productId) => {
  return some(getSeedApplicationsForZone(zone), seedApplication => {
    return seedApplication.product.id === productId;
  });
};

export const getSeedApplicationProductsInZones = (zones) => {
  const products = [];
  forEach(zones, zone => {
    const seedApplications = get(zone, `meta.applications.${applicationTypes.SEED}`, []);

    seedApplications.forEach(seedApplication => {
      const product = seedApplication.product;
      products.push(product);
    });
  });
  return uniqBy(products, 'id');
};

export const getNumSeedApplicationProductsInZones = (zones) => {
  return getSeedApplicationProductsInZones(zones).length;
};

export const isZoneApplyingAllSeedProducts = ({zone, seedApplicationProducts}) => {
  const isZoneMissingAProduct = seedApplicationProducts.some(product => {
    const seedApplications = get(zone, `meta.applications.${applicationTypes.SEED}`, []);
    // since zones can have no product assigned, test for equality of product assignment rather than just product id
    return (seedApplications.findIndex(application => isEqual(get(application, 'product'), product)) === -1);
  });
  return !isZoneMissingAProduct;
};

export const getSeedApplicationsByProductInZones = ({zones, seedApplicationProductId}) => {
  const applications = [];
  forEach(zones, zone => {
    const seedApplications = get(zone, `meta.applications.${applicationTypes.SEED}`, []);
    const foundApplication = seedApplications.find(
      application => get(application, 'product.id')===seedApplicationProductId);
    if (foundApplication) { applications.push(foundApplication); }
  });
  return applications;
};

// TODO: this should probably make use of getSeedApplicationsForZones instead of
// reinventing the wheel
export const getFirstSeedApplicationsInZones = (zones) => {
  const applications = [];
  forEach(zones, zone => {
    const firstApplication = get(zone, `meta.applications.${applicationTypes.SEED}`,[])[0];
    if (firstApplication) { applications.push(firstApplication); }
  });
  return applications;
};


export const getSeedSummaryForZone = (zone) => getSeedApplicationsForZone(zone)[0];

export const hasSeedApplicationsForZones = (zones) => {
  const seedApplications = getSeedApplicationsForZones(zones);
  return some(seedApplications, (applications) => !!(get(applications[0], 'rate.q') || 0));
};
